export const PHONE_MAX_LENGTH = {
  BR: 11, // Brasil
  AR: 10, // Argentina
  CO: 10, // Colômbia
  VE: 10, // Venezuela
  UY: 9, // Uruguai
  PY: 9, // Paraguai
  BO: 9, // Bolívia
  PE: 8, // Peru
  DEFAULT: 15,
}

export const returnMaxLength = countryCode => {
  switch (countryCode) {
    case '+55': // Brasil
      return PHONE_MAX_LENGTH.BR

    default:
      return PHONE_MAX_LENGTH.DEFAULT
  }
}

export const FormatPhone = (phone, countryCode) => {
  let val = phone.replace(/\D/g, '')

  // Limita a quantidade de dígitos de acordo com o código do país
  const maxLength = returnMaxLength(countryCode)

  if (val.length > maxLength) {
    val = val.substring(0, maxLength)
  }

  // Formata o número de acordo com o código do país
  switch (countryCode) {
    case '+55': // Brasil
      if (val.length > 2) {
        val = val.replace(/^(\d{2})(\d)/g, '($1) $2')
      }
      if (val.length > 7) {
        val = val.replace(/(\d)(\d{4})$/, '$1-$2')
      }
      break
    default:
      break
  }

  return val
}
